import helpBtn from "@assets/imgs/btns/help-btn.png";
import { AudioManager } from "@/phaser/core/audio/AudioManager";
import { BaseButton } from "@phaser/ui/btns/BaseButton";
export class HelpBtn extends BaseButton {
  private bg: Phaser.GameObjects.Image;
  static preload(scene: Phaser.Scene) {
    scene.load.image("help-btn", helpBtn);
  }
  constructor(scene: Phaser.Scene, x: number, y: number, onClick: () => void) {
    super(scene, x, y, {
      onClick,
      sfx: () => AudioManager.playSfx("sfx-button"),
      onPress: () => this.setPressedStyle(),
      onRelease: () => this.resetButton(),
    });
    this.bg = scene.add.image(0, 0, "help-btn").setOrigin(0.5);
    this.add(this.bg);
    this.enableButton(this.bg.width, this.bg.height);
    scene.add.existing(this);
  }
  private setPressedStyle() {
    this.setScale(0.9);
  }
  private resetButton() {
    this.setScale(1);
  }
}
